import {
  actions,
  getAllReportProblemAsDataTableAsync,
  deleteReportProblemOptionAsync,
  createReportProblemOptionAsync,
  updateReportProblemOptionAsync,
  getAllReportProblemOptionsAsync,
} from './slices';

export const ReportProblemActions = {
  ...actions,
  getAllReportProblemAsDataTableAsync,

  deleteReportProblemOptionAsync,
  createReportProblemOptionAsync,
  updateReportProblemOptionAsync,
  getAllReportProblemOptionsAsync,
};
